import {InputText} from '@/components/Form/index.mjs'
import FormItemBizProp from '../components/FormItemBizProp.jsx'
import FormChooseDesign from '../_DESIGN/FormChooseDesign.jsx'
import Model from './ModelDb.mjs'

export const FormItemDbName = props => (
    <FormItemBizProp
        Model={Model}
        prop="dbName"
        {...props}
    >
        <InputText allowClear />
    </FormItemBizProp>
)

export default function FormChooseDb(props) {
    return (
        <FormChooseDesign {...props}>
            <FormItemDbName />
        </FormChooseDesign>
    )
}
